import React, { useState, useEffect } from "react";
import api from "../../../api";

const Notification = ({ profileData, setProfileData }) => {
  const [languageData, setLanguageData] = useState(null);
  const availableNotifications = profileData?.available_notifications || [];
  const activeNotifications = profileData?.notifications || [];
  const activeConsents = profileData?.consents || [];
  const [notifications, setNotifications] = useState({
    emailExpertAvailable: false,
    smsExpertAvailable: false,
    emailReply: false,
    smsReply: false,
    newsletter: false,
    promotionalOffers: false,
  });
  const [consents, setConsents] = useState({
    statisticsCookies: false,
    commerceCookies: false,
    preferencesCookies: false,
    optimisationCookies: false,
  });
  useEffect(() => {
    setNotifications({
      emailExpertAvailable: activeNotifications.includes(
        "favorite_expert_available_email",
      ),
      smsExpertAvailable: activeNotifications.includes(
        "favorite_expert_available_sms",
      ),
      emailReply: activeNotifications.includes("expert_reply_message_email"),
      smsReply: activeNotifications.includes("expert_reply_message_sms"),
      newsletter: activeNotifications.includes("newsletter_email"),
      promotionalOffers: activeNotifications.includes(
        "promotional_offers_email",
      ),
    });
    setConsents({
      statisticsCookies: activeConsents.includes("statistics_cookies"),
      commerceCookies: activeConsents.includes("commerce_cookies"),
      preferencesCookies: activeConsents.includes("preferences_cookies"),
      optimisationCookies: activeConsents.includes("optimisation_cookies"),
    });
  }, [profileData]);

  const notificationTypeMap = {
    emailExpertAvailable: "favorite_expert_available_email",
    smsExpertAvailable: "favorite_expert_available_sms",
    emailReply: "expert_reply_message_email",
    smsReply: "expert_reply_message_sms",
    newsletter: "newsletter_email",
    promotionalOffers: "promotional_offers_email",
  };
  const consentTypeMap = {
    statisticsCookies: "statistics_cookies",
    commerceCookies: "commerce_cookies",
    preferencesCookies: "preferences_cookies",
    optimisationCookies: "optimisation_cookies",
  };

  const toggleNotification = async (key) => {
    const newStatus = !notifications[key];

    setNotifications((prev) => ({
      ...prev,
      [key]: newStatus,
    }));

    try {
      await api.post("/accounts/profile/notification/update", {
        type: notificationTypeMap[key],
        status: newStatus ? 1 : 0,
      });
      setProfileData((prev) => {
        const notifications = [...(prev.notifications || [])];

        if (newStatus) {
          if (!notifications.includes(notificationTypeMap[key])) {
            notifications.push(notificationTypeMap[key]);
          }
        } else {
          const index = notifications.indexOf(notificationTypeMap[key]);
          if (index > -1) notifications.splice(index, 1);
        }

        return {
          ...prev,
          notifications,
        };
      });
    } catch (error) {
      console.error(error);

      setNotifications((prev) => ({
        ...prev,
        [key]: !newStatus,
      }));
    }
  };
  async function getUserCountryOnce() {
    const cached = localStorage.getItem("userCountry");
    if (cached) return JSON.parse(cached);

    try {
      const ipRes = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipRes.json();

      const lookupRes = await fetch(
        "https://builder.leadsy.pro/lookup_api/v1/" + ipData.ip,
      );

      const lookupData = await lookupRes.json();
      const data = lookupData?.data || {};

      const result = {
        ip: data.ip || ipData.ip,
        city: data.city || "Unknown City",
        region: data.region || "Unknown Region",
        country: data.country || "Unknown",
        timezone:
          data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      const country = lookupData?.data?.country || "us";
      localStorage.setItem("userCountry", JSON.stringify(result));

      return result;
    } catch (e) {
      return {
        ip: "",
        city: "Unknown City",
        region: "Unknown Region",
        country: "US",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
    }
  }

  const toggleConsent = async (key) => {
    const newStatus = !consents[key];

    setConsents((prev) => ({
      ...prev,
      [key]: newStatus,
    }));
    const locationData = await getUserCountryOnce();
    try {
      await api.post("/accounts/profile/consent/update", {
        type: consentTypeMap[key],
        status: newStatus ? 1 : 0,
        ip_address: locationData.ip,
        user_agent: navigator.userAgent,
      });
      setProfileData((prev) => {
        const consents = [...(prev.consents || [])];

        if (newStatus) {
          if (!consents.includes(consentTypeMap[key])) {
            consents.push(consentTypeMap[key]);
          }
        } else {
          const index = consents.indexOf(consentTypeMap[key]);
          if (index > -1) consents.splice(index, 1);
        }

        return {
          ...prev,
          consents,
        };
      });
    } catch (error) {
      console.error(error);

      setConsents((prev) => ({
        ...prev,
        [key]: !newStatus,
      }));
    }
  };
  const isAvailable = (key) => availableNotifications.includes(key);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../../lang/profile/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  return (
    <div
      className="tab-pane fade p-4 border-0 active show"
      id="notif-tab-pane"
      role="tabpanel"
      aria-labelledby="notif-tab"
      tabIndex="0"
    >
    {availableNotifications.length > 0 && (
      <div className="row gy-3">
        <h6 className="fs-17" >
          {languageData.tab_notifications.notifications}
        </h6>
        {isAvailable("favorite_expert_available_email") && (
          <div className="col-xl-12">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                name="favorite_expert_available_email"
                id="emailExpertSwitch"
                checked={notifications.emailExpertAvailable}
                onChange={() => toggleNotification("emailExpertAvailable")}
              />
              <label className="form-check-label" htmlFor="emailExpertSwitch">
                {languageData.tab_notifications.expert_available_mail}
              </label>
            </div>
          </div>
        )}

        {isAvailable("favorite_expert_available_sms") && (
          <div className="col-xl-12">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                name="favorite_expert_available_sms"
                id="smsExpertSwitch"
                checked={notifications.smsExpertAvailable}
                onChange={() => toggleNotification("smsExpertAvailable")}
              />
              <label className="form-check-label" htmlFor="smsExpertSwitch">
                {languageData.tab_notifications.expert_available_sms}
              </label>
            </div>
          </div>
        )}

        {isAvailable("expert_reply_message_email") && (
          <div className="col-xl-12">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                name="expert_reply_message_email"
                id="emailReplySwitch"
                checked={notifications.emailReply}
                onChange={() => toggleNotification("emailReply")}
              />
              <label className="form-check-label" htmlFor="emailReplySwitch">
                {languageData.tab_notifications.reply_mail}
              </label>
            </div>
          </div>
        )}

        {isAvailable("expert_reply_message_sms") && (
          <div className="col-xl-12">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                name="expert_reply_message_sms"
                id="smsReplySwitch"
                checked={notifications.smsReply}
                onChange={() => toggleNotification("smsReply")}
              />
              <label className="form-check-label" htmlFor="smsReplySwitch">
                {languageData.tab_notifications.reply_sms}
              </label>
            </div>
          </div>
        )}
      </div> 
    )}
     {availableNotifications.length > 0 && (
      <div className="row gy-3 mt-3">
        <h6 className="fs-17" >
          {languageData.tab_notifications.subscriptions}
        </h6>
        {isAvailable("newsletter_email") && (
          <div className="col-xl-12">
            <h6>{languageData.tab_notifications.newsletter}</h6>

            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                name="newsletter_email"
                id="newsletter"
                checked={notifications.newsletter}
                onChange={() => toggleNotification("newsletter")}
              />
              <label className="form-check-label" htmlFor="newsletter">
                {languageData.tab_notifications.newsletter_desc}
              </label>
            </div>
          </div>
        )}
        {isAvailable("promotional_offers_email") && (
          <div className="col-xl-12">
            <h6>{languageData.tab_notifications.offres_promotionelles}</h6>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                name="promotional_offers_email"
                id="promotionalOffers"
                checked={notifications.promotionalOffers}
                onChange={() => toggleNotification("promotionalOffers")}
              />
              <label className="form-check-label" htmlFor="promotionalOffers">
                {languageData.tab_notifications.offres_promotionelles_desc}
              </label>
            </div>
          </div>
        )}
      </div>
    )}
      <div className="row gy-3 mt-3">
        <h6 className="fs-17">
          {languageData.tab_notifications.cookies}
        </h6>
        <div className="col-xl-12">
          <h6>{languageData.tab_notifications.statistiques}</h6>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              name="statisticsCookies"
              id="statisticsCookies"
              checked={consents.statisticsCookies}
              onChange={() => toggleConsent("statisticsCookies")}
            />
            <label className="form-check-label" htmlFor="statisticsCookies">
              {languageData.tab_notifications.statistiques_desc}
            </label>
          </div>
        </div>
        <div className="col-xl-12">
          <h6>{languageData.tab_notifications.marketing}</h6>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              name="commerceCookies"
              role="switch"
              id="commerceCookies"
              checked={consents.commerceCookies}
              onChange={() => toggleConsent("commerceCookies")}
            />
            <label className="form-check-label" htmlFor="commerceCookies">
              {languageData.tab_notifications.marketing_desc}
            </label>
          </div>
        </div>

        <div className="col-xl-12">
          <h6>{languageData.tab_notifications.cookies_de_préférences}</h6>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              name="preferencesCookies"
              role="switch"
              id="preferencesCookies"
              checked={consents.preferencesCookies}
              onChange={() => toggleConsent("preferencesCookies")}
            />
            <label className="form-check-label" htmlFor="preferencesCookies">
              {languageData.tab_notifications.cookies_de_préférences_desc}
            </label>
          </div>
        </div>

        <div className="col-xl-12">
          <h6>{languageData.tab_notifications.cookies_nécessaires}</h6>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              name="optimisationCookies"
              id="optimisationCookies"
              checked={consents.optimisationCookies}
              onChange={() => toggleConsent("optimisationCookies")}
            />
            <label className="form-check-label" htmlFor="optimisationCookies">
              {languageData.tab_notifications.cookies_nécessaires_desc}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notification;
